import React from 'react'

export default function TrustBar() {
  const usps = [
    {
      title: '24/7 bestilling',
      subtitle: 'Åbent alle ugens dage og helligdage',
      icon: 'fa-solid fa-clock',
    },
    {
      title: '-20°C til +25°C',
      subtitle: 'Køl, frost og kontrolleret varme',
      icon: 'fa-solid fa-temperature-half',
    },
    {
      title: 'Op til 8 europaller',
      subtitle: 'Samt transport fra 1 kg og specialgods',
      icon: 'fa-solid fa-pallet',
    },
    {
      title: 'Afgang inden for 2 timer',
      subtitle: 'Hurtig udrykning ved akutte behov',
      icon: 'fa-solid fa-bolt',
    },
  ]

  return (
    <section className="relative z-20 -mt-8 sm:-mt-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-2xl border border-slate-200/90 shadow-lg shadow-slate-200/50 p-4 sm:p-6 lg:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 divide-y sm:divide-y-0 sm:divide-x divide-slate-100">
          {usps.map((usp, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-4 ${
                idx > 0 ? 'pt-5 sm:pt-0 sm:pl-6' : ''
              }`}
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-sky-50 text-sky-600 border border-sky-100">
                <i className={`${usp.icon} text-xl`} aria-hidden="true" />
              </div>
              <div className="min-w-0">
                <h4 className="text-base font-bold text-slate-900 tracking-tight">
                  {usp.title}
                </h4>
                <p className="mt-0.5 text-xs text-slate-600 leading-snug">
                  {usp.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
